$(document).ready(function() {

  if ($("#widgetUpdate").length) {

    // Creates the shortened url and deposits it into the iframe and copy box.
    $('#widgetUpdate').submit(function() {

      $.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
      });
      //generateUrl();

      $.post($('#widgetUpdate').attr('action'), $('#widgetUpdate').serialize(), function(data) {

        var url = $('#widgetUpdate').attr('data-widget-short') +'/'+ data.identifier;

        $('#widgetUrl').val(url);
        $('#widget-iframe').attr("src", url);

        $('#embedCode').attr('value', "<iframe src='" + url + "' width='100%' height='600px' class='eventWidget'></iframe>");
      });

      return false;
    });

    // Create the non-truncated version of the url from the form inputs
    function generateUrl() {
      $('#widget_url').val('');
      var url = $('#widgetUpdate').attr('data-url-root') + '?=x&' + $("#widgetUpdate").serialize();
      $('#widget_url').val(url);
    }


    // Selects all Rounds when "all rounds" button is selected.
    $(".select-all-toggle").each(function() {
      var name = $(this).find('input').first().attr("name");

      toggleSelectAll(name);

      $('input[name="' + name + '"]').change(function() {

        toggleSelectAll($(this).attr('name'));
      });

    });

    function toggleSelectAll(name) {
      if ($('input[name="' + name + '"]:checked').val() == 1) {
        $('input[name="' + name + '"]').parents(".select-all-toggle").first().find('input[type="checkbox"]').prop('checked', true);
      } else {
        $('input[name="' + name + '"]').parents(".select-all-toggle").first().find('input[type="checkbox"]').prop('checked', false);
      };
    }

    // Copy url button
    $(".copy-text").click(function() {

      var copyText = $(this).parent().parent().children(".copy-text-content");

      if (navigator.userAgent.match(/ipad|iphone/i)){

        var textArea = document.createElement('textArea');
        var holder = document.getElementById('widgetHolder');
        textArea.value = copyText.val();
        holder.appendChild(textArea);

        var range = document.createRange();
        range.selectNodeContents(textArea);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textArea.setSelectionRange(0, 999999);

        document.execCommand("Copy");
        holder.removeChild(textArea);

      }else{
        copyText.select();
        document.execCommand("Copy");

      }

    })

    // toggle display max displayed competitors
    $('.round-checkbox').click(function() {
      if ($('.round-checkbox:checked').length > 0) {
        $('#max-round-competitors').show();
      } else {
        $('#max-round-competitors').hide();
      }
    });

    $('.division-checkbox').click(function() {
      if ($('.division-checkbox:checked').length > 0) {
        $('#max-division-competitors').show();
      } else {
        $('#max-division-competitors').hide();
      }
    });

    $('.team-checkbox').click(function() {
      if ($('.team-checkbox:checked').length > 0) {
        $('#max-teams').show();
      } else {
        $('#max-teams').hide();
      }
    });

  }
});
